import React, { useState } from 'react'
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js'

function MenuPaymentForm({
  total,
  submitting,
  paymentReady,
  onPaymentReady,
  onSubmit,
}) {
  const stripe = useStripe()
  const elements = useElements()
  const [localError, setLocalError] = useState('')

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (!stripe || !elements || submitting) return

    setLocalError('')
    const { error: submitError } = await elements.submit()
    if (submitError) {
      setLocalError(submitError.message)
      return
    }

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
    })

    if (error) {
      setLocalError(error.message)
      return
    }

    if (paymentIntent?.status === 'succeeded') {
      onSubmit(paymentIntent.id)
    } else {
      setLocalError('Payment could not be completed. Please try again.')
    }
  }

  return (
    <form className="luxury-menu__payment-form" onSubmit={handleSubmit}>
      <PaymentElement
        onChange={(event) => onPaymentReady(Boolean(event.complete))}
      />
      {localError && <p className="luxury-menu__drawer-error">{localError}</p>}
      <button
        type="submit"
        className="luxury-menu__submit-btn"
        disabled={!stripe || !elements || !paymentReady || submitting}
      >
        {submitting ? 'Processing payment…' : `Pay ${total}`}
      </button>
    </form>
  )
}

export default function MenuPayment({
  stripePromise,
  clientSecret,
  total,
  submitting,
  onPaymentReady,
  onSubmit,
}) {
  const [paymentReady, setPaymentReady] = useState(false)

  if (!clientSecret || !stripePromise) {
    return (
      <p className="luxury-menu__drawer-note">Preparing secure checkout…</p>
    )
  }

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance: {
          theme: 'night',
          variables: {
            colorPrimary: '#c8a45d',
            colorBackground: '#12100f',
            colorText: '#f4efe6',
            colorDanger: '#f2a6a6',
            borderRadius: '12px',
          },
        },
      }}
    >
      <MenuPaymentForm
        total={total}
        submitting={submitting}
        paymentReady={paymentReady}
        onPaymentReady={(ready) => {
          setPaymentReady(ready)
          onPaymentReady(ready)
        }}
        onSubmit={onSubmit}
      />
    </Elements>
  )
}
